import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Box } from "@mui/material";
import Alert from "@mui/material/Alert";
import FormControl from "@mui/material/FormControl";

function CloseForm2({ nextStep, handleChange, values }) {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const formIsValid = () => {
    const formErrors = {};

    if (!values.vtrnbr) formErrors.vtrnbr = "The VTR Number is required.";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const _next = (event) => {
    event.preventDefault();
    if (!formIsValid()) return;

    nextStep();
  };

  const _cancel = (event) => {
    event.preventDefault();
    navigate(`${process.env.PUBLIC_URL}/ivr`, {
      state: { trip_id: values.vtr_nbr, vesselNbr: values.permitNbr },
    });
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <FormControl variant="standard">
          <TextField
            name="trip_id"
            label="Trip Id:"
            sx={{
              number: {
                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                  {
                    "-webkit-appearance": "none",
                    margin: 0,
                  },
              },
            }}
            type="number"
            placeholder="Trip Id"
            variant="standard"
            defaultValue={values.tripid}
            onChange={handleChange("trip_id")}
            required={true}
            disabled
            inputProps={{ style: { textAlign: "center" } }}
          />
        </FormControl>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <FormControl>
          <TextField
            name="vtrnbr"
            label="VTR Number:"
            sx={{
              number: {
                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                  {
                    "-webkit-appearance": "none",
                    margin: 0,
                  },
              },
            }}
            type="number"
            placeholder="VTR Number"
            variant="standard"
            defaultValue={values.vtrnbr}
            onChange={handleChange("vtrnbr")}
            inputProps={{ style: { textAlign: "center" } }}
          />
        </FormControl>
      </Box>
      {errors.vtrnbr && <Alert severity="error">{errors.vtrnbr}</Alert>}
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Cancel
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default CloseForm2;
